import React, { useState } from "react";
import FlexWrapper from "../../Atoms/FlexWrapper";
import Input from "../../Atoms/Input/Input";
import MarginWrapper from "../../Atoms/MarginWrapper";
import Typography from "../../Atoms/Typography";
import { Colors } from "../../Utils/Colors";
import Button from "../../Atoms/Button";
import "./GetInTouch.css";

import GIF from "../../Lottie/email.gif";
import Modal from "../../Atoms/Modal";

import emailkey, { anotherEmail } from "../../Utils/emailkey";

const GetInTouch = () => {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [subject, setSubject] = useState("");
  const [subjectError, setSubjectError] = useState("");

  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState("");

  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleNameChange = (value) => {
    setName(value);
    setNameError(value === "" ? "Required" : "");
  };

  const handelEmailChange = (value) => {
    const emailRegex = /\S+@\S+\.\S+/;
    setEmail(value);
    setEmailError(value !== "" && !emailRegex.test(value) ? "Please Enter Valid Email Id" : "");
  };

  const handelNumberChange = (value) => {
    const numberRegex = /[^0-9]/g;
    if (!numberRegex.test(value)) {
      setPhoneNumber(value);
      setPhoneNumberError(value.length === 10 || value.length === 0 ? "" : "Phone number must be 10 digits");
    }
  };

  const handleMessageChange = (value) => {
    setMessage(value);
    setMessageError(value === "" ? "Required" : "");
  };

  const handelDisable = () => {
    return !name || !message || nameError || emailError || phoneNumberError || messageError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (handelDisable()) return;

    const inputFields = {
      ToName: "Rajesh",
      Name: name,
      PhoneNumber: phoneNumber,
      UserEmail: email,
      Subject: subject,
      Message: message,
    };

    const data = {
      service_id: emailkey.service_id,
      template_id: emailkey.template_id,
      user_id: emailkey.user_id,
      template_params: inputFields,
    };
    
    const dataCopy = {
      service_id: anotherEmail.service_id,
      template_id: anotherEmail.template_id,
      user_id: anotherEmail.user_id,
      template_params: inputFields,
    };

    setLoader(true);
    
    Promise.all([
      fetch("https://api.emailjs.com/api/v1.0/email/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataCopy),
      }),
      fetch("https://api.emailjs.com/api/v1.0/email/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
    ]).then(() => {
      setLoader(false);
      setOpenModal(true);
      setName("");
      setPhoneNumber("");
      setEmail("");
      setSubject("");
      setMessage("");
      setNameError("");
      setPhoneNumberError("");
      setEmailError("");
      setMessageError("");
    });
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="footer-contact-form">
      <Modal
        onClose={() => setOpenModal(false)}
        showModal={openModal}
        width={isMobile ? "320px" : "400px"}
        height={isMobile ? "310px" : "400px"}
        borderRadius="20px"
        background="#FFF"
        showCloseIcon={true}
      >
        <FlexWrapper flexDirection={"column"} alignItems={"center"}>
          <img
            src={GIF}
            alt=""
            width={isMobile ? "200px" : "300px"}
            height={isMobile ? "200px" : "300px"}
          />
          <MarginWrapper mt={"10px"} mb={"10px"} ml={"20px"} mr={"20px"}>
            <Typography
              text={"Thank you for reaching out to us, our support team will contact you soon."}
              color={Colors.BigStone}
              sizeAndWeight={"16px-500"}
              textAlign={"center"}
            />
          </MarginWrapper>
        </FlexWrapper>
      </Modal>
      
      <div className="form-header">
        <Typography
          text="Got any questions?"
          color={Colors.White}
          sizeAndWeight={isMobile ? "1.2rem-700" : "1.3rem-700"}
        />
        <Typography
          text="Please fill the below details"
          color={Colors.White}
          sizeAndWeight={isMobile ? "0.9rem-400" : "1rem-400"}
          className="form-subtitle"
        />
      </div>
      
      <form onSubmit={handleSubmit} className="contact-form">
  <div className="form-grid">
    {/* Name */}
    <div className="form-group">
      <label className="form-label">Name *</label>
      <Input
        label=""
        isRequired={true}
        value={name}
        errorMessage={nameError}
        onChange={handleNameChange}
        className="form-input-field"
        placeholder="Your name"
      />
      {nameError && <span className="error-text">{nameError}</span>}
    </div>

    {/* Phone Number */}
    <div className="form-group">
      <label className="form-label">Phone Number *</label>
      <Input
        label=""
        isRequired={true}
        value={phoneNumber}
        errorMessage={phoneNumberError}
        onChange={handelNumberChange}
        className="form-input-field"
        placeholder="Phone number"
        type="tel"
      />
      {phoneNumberError && <span className="error-text">{phoneNumberError}</span>}
    </div>

    {/* Email */}
    <div className="form-group">
      <label className="form-label">Email *</label>
      <Input
        label=""
        isRequired={true}
        value={email}
        errorMessage={emailError}
        onChange={handelEmailChange}
        className="form-input-field"
        placeholder="Your email"
        type="email"
      />
      {emailError && <span className="error-text">{emailError}</span>}
    </div>

    {/* Subject */}
    <div className="form-group">
      <label className="form-label">Subject</label>
      <Input
        label=""
        isRequired={false}
        value={subject}
        errorMessage={subjectError}
        onChange={setSubject}
        className="form-input-field"
        placeholder="Subject (optional)"
      />
      {subjectError && <span className="error-text">{subjectError}</span>}
    </div>

    {/* Message - Full width */}
    <div className="form-group form-group-full">
      <label className="form-label">Message *</label>
      <textarea
        value={message}
        onChange={(e) => handleMessageChange(e.target.value)}
        className="form-textarea"
        rows={4}
        placeholder="Your message here..."
      />
      {messageError && <span className="error-text">{messageError}</span>}
    </div>

    {/* Submit Button */}
    <div className="form-submit">
      <Button
        buttonText={loader ? "Sending..." : "Submit"}
        background={Colors.White}
        color={Colors.BigStone}
        onPress={handleSubmit}
        disable={handelDisable()}
        width={"160px"}
        height={"44px"}
        borderRadius={"6px"}
        isLoading={loader}
        type="submit"
        className="submit-btn"
      />
    </div>
  </div>
</form>

    </div>
  );
};

export default GetInTouch;